import { INIT_SIDEBAR, SHOW_SIDEBAR, SHOW_SIDEBAR_COLLAPSE, CHANGE_ACTIVE_SIDEBAR_ITEM } from '../actions/types/index';

const INITIAL_STATE = {
  sidebarShow: false,
  sidebarCollapse: true,
  activeItem: window.location.pathname || '/'
};
export default function sideBarReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SHOW_SIDEBAR_COLLAPSE:
      return { ...state, sidebarCollapse: action.payload };
    case SHOW_SIDEBAR:
      return { ...state, sidebarShow: action.payload };
    case INIT_SIDEBAR:
      return { ...INITIAL_STATE };
    case CHANGE_ACTIVE_SIDEBAR_ITEM:
      return {
        ...state,
        activeItem: action.payload
      };
    default:
      return state;
  }
}
